function getChannelName(channel) {
  if (!channel) return '';
  return String(channel.app_name || '').trim();
}

export function getChannelNumber(channel) {
  if (!channel) return '';
  return String(channel.channel_number || channel.wa_phone_number || '').trim();
}

function formatChannelNumber(number) {
  if (!number) return '';

  const normalizedNumber = number.replace(/\s+/g, '');
  if (normalizedNumber.startsWith('+91')) {
    return `+91 ${normalizedNumber.slice(3)}`;
  }
  if (normalizedNumber.startsWith('91')) {
    return `+91 ${normalizedNumber.slice(2)}`;
  }

  return `+91 ${normalizedNumber}`;
}

export function getChannelLabel(channel) {
  if (!channel) return '';

  const name = getChannelName(channel);
  const number = formatChannelNumber(getChannelNumber(channel));

  if (name && number) {
    return `${name} (${number})`;
  }

  return name || number || '';
}

export function isSameChannel(a, b) {
  if (a === b) return true;
  if (!a || !b) return false;

  const aNumber = getChannelNumber(a);
  const bNumber = getChannelNumber(b);
  if (aNumber && bNumber) {
    return aNumber === bNumber;
  }

  if (a.mongo_id != null && b.mongo_id != null) {
    return String(a.mongo_id) === String(b.mongo_id);
  }
  if (a.app_id != null && b.app_id != null) {
    return String(a.app_id) === String(b.app_id);
  }

  return getChannelLabel(a) !== '' && getChannelLabel(a) === getChannelLabel(b);
}
